
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { cn } from "@/lib/utils";
import { JournalEntry } from "@/hooks/journal/types";
import { ExportFormat } from "@/utils/exportUtils";
import ExportDialog from "./ExportDialog";
import { useSettings } from "@/context/SettingsContext";

interface ExportButtonProps {
  entries: JournalEntry[];
  variant?: "default" | "outline" | "ghost" | "secondary";
  size?: "default" | "sm" | "lg" | "icon";
  defaultFormat?: ExportFormat;
  allowDateFilter?: boolean;
  showText?: boolean;
  className?: string;
  disabled?: boolean;
}

const ExportButton: React.FC<ExportButtonProps> = ({
  entries,
  variant = "outline",
  size = "sm",
  defaultFormat = "pdf",
  allowDateFilter = false,
  showText = true,
  className,
  disabled = false
}) => {
  const [showExportDialog, setShowExportDialog] = useState(false);
  const { enableRpgMode } = useSettings();

  const handleClick = () => {
    setShowExportDialog(true);
  };

  const buttonText = enableRpgMode ? "Archive" : "Export";

  return (
    <>
      <Button
        variant={variant}
        size={size}
        onClick={handleClick}
        disabled={disabled || entries.length === 0}
        className={cn("flex items-center gap-1", className)}
      >
        <Download className="h-3.5 w-3.5" />
        {showText && <span>{buttonText}</span>}
      </Button>

      <ExportDialog
        isOpen={showExportDialog}
        onClose={() => setShowExportDialog(false)}
        entries={entries}
        defaultFormat={defaultFormat}
        allowDateFilter={allowDateFilter}
      />
    </>
  );
};

export default ExportButton;
